export enum SaleOrderType {
  IsB2C = 0,
  IsB2B = 1,
  All = 2,
}
